import React, { useState } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Slider,
} from '@mui/material';
import { Box } from '@mui/system';

import { IBookingAttachment } from '@homeporter/types';
import { baseUrl } from '../../utils/helpers';

const ViewAttachments = ({
  attachments,
  selectedAttachmentIndex,
  setSelectedAttachmentIndex,
}: {
  attachments: IBookingAttachment[];
  selectedAttachmentIndex: number;
  setSelectedAttachmentIndex: (index: number) => void;
}) => {
  const [zoom, setZoom] = useState(100);
  const isNativeViewer =
    attachments[selectedAttachmentIndex]?.url ||
    attachments[selectedAttachmentIndex]?.file;

  return (
    <Dialog
      open={selectedAttachmentIndex > -1}
      onClose={() => setSelectedAttachmentIndex(-1)}
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '90vw',
          height: '90vh',
          borderRadius: '.5rem',
        },
      }}>
      <DialogTitle>
        File Preview - {attachments[selectedAttachmentIndex]?.name}
        {!attachments[selectedAttachmentIndex]?.file ? '' : ' (LOCAL)'}
      </DialogTitle>
      <DialogContent>
        {isNativeViewer && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',

              height: `${zoom}%`,
            }}>
            {attachments[selectedAttachmentIndex]?.type ===
              'application/msword' ||
            attachments[selectedAttachmentIndex]?.type ===
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ? (
              <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                  baseUrl(attachments[selectedAttachmentIndex]?.url || '') ||
                    URL.createObjectURL(
                      attachments[selectedAttachmentIndex]?.file as File,
                    ),
                )}`}
                title={attachments[selectedAttachmentIndex]?.name}
                width="100%"
                height="100%"
                frameBorder="0"
                style={{
                  height: '100%',
                  minHeight: '600px',
                }}
              />
            ) : attachments[selectedAttachmentIndex]?.type.startsWith(
                'image/',
              ) ? (
              <img
                src={
                  baseUrl(attachments[selectedAttachmentIndex]?.url || '') ||
                  URL.createObjectURL(
                    attachments[selectedAttachmentIndex]?.file as File,
                  )
                }
                alt={attachments[selectedAttachmentIndex]?.name}
                style={{ maxWidth: '100%', maxHeight: '100%' }}
              />
            ) : attachments[selectedAttachmentIndex]?.type ===
              'application/pdf' ? (
              <iframe
                src={
                  baseUrl(attachments[selectedAttachmentIndex]?.url || '') ||
                  URL.createObjectURL(
                    attachments[selectedAttachmentIndex]?.file as File,
                  )
                }
                title={attachments[selectedAttachmentIndex]?.name}
                width="100%"
                height="100%"
                style={{
                  colorScheme: 'light',
                }}
              />
            ) : (
              <Typography>
                Preview not available for{' '}
                {attachments[selectedAttachmentIndex]?.name || ''}
              </Typography>
            )}
          </Box>
        )}
        {!(
          !!attachments[selectedAttachmentIndex]?.url ||
          !!attachments[selectedAttachmentIndex]?.file
        ) && (
          <Box>
            <Typography>PREVIEW NOT AVAILABLE</Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        {!isNativeViewer && (
          <Box sx={{ mr: 'auto' }}>
            <Slider
              min={25}
              max={200}
              value={zoom}
              valueLabelDisplay="auto"
              valueLabelFormat={(value) => `${value}%`}
              onChange={(_, value) => {
                setZoom(value as number);
              }}
              sx={{ width: 100, ml: '1rem', mr: '1rem' }}
            />
          </Box>
        )}
        <Button
          sx={{
            mr: attachments.length > 1 ? 'auto' : 0,
          }}
          onClick={() => setSelectedAttachmentIndex(-1)}>
          Close
        </Button>

        {attachments.length > 1 && (
          <>
            <Button
              disabled={selectedAttachmentIndex === 0}
              onClick={() =>
                setSelectedAttachmentIndex(selectedAttachmentIndex - 1)
              }>
              Previous
            </Button>
            <Button
              disabled={selectedAttachmentIndex === attachments.length - 1}
              onClick={() =>
                setSelectedAttachmentIndex(selectedAttachmentIndex + 1)
              }>
              Next
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ViewAttachments;
